import { ISelfEmployedSchema } from '../../../../../repositories/monolith-python/entities/offer/SelfEmployedSchema';
import { IOfferState } from '../../../../reducers';

export const mapSelfEmployed = (offer: IOfferState): ISelfEmployedSchema | null => {
  const { selfEmployedData } = offer;

  // удаляем объект самозанятого
  if (!selfEmployedData || !selfEmployedData.isEnabled) {
    return null;
  }

  const { inn } = selfEmployedData;

  return {
    inn,
  };
};
